export {
    type FileCategory,
    type FileIconConfig,
    getFileIcon,
    getFileIconForMime,
    mimeTypeToCategory,
} from '@tinycld/core/file-viewer/file-icons'
